import CSIInstance from './CSI';
const requiredFields = {
    projectName: CSIInstance.setProjectName.bind(CSIInstance),
    stand: CSIInstance.setStand.bind(CSIInstance),
};
export const CSI = options => {
    for (let optionName in options) {
        if (!requiredFields.hasOwnProperty(optionName))
            continue;
        requiredFields[optionName](options[optionName]);
    }
    return CSIInstance.run;
};
